import React, { useEffect, useState } from "react";

const LGTVInfo = () => {
  const [systemInfo, setSystemInfo] = useState(null);

  useEffect(() => {
    const getSystemInfo = async () => {
      try {
        if (window.webOS && window.webOS.service) {
          const request = window.webOS.service.request(
            "luna://com.webos.service.tv.systemproperty",
            {
              method: "getSystemInfo",
              parameters: {
                keys: ["modelName", "firmwareVersion", "UHD", "sdkVersion"],
              },

              onComplete: (inResponse) => {
                const isSucceeded = inResponse.returnValue;
                if (isSucceeded) {
                  // console.log("Result: " + JSON.stringify(inResponse));
                  setSystemInfo(inResponse);
                  localStorage.setItem(
                    "systemInfo",
                    JSON.stringify(inResponse)
                  );
                  const systemInfo = localStorage.getItem("systemInfo");
                  const parsedSystemInfo = JSON.parse(systemInfo);
                  localStorage.setItem("parsedSystemInfo", parsedSystemInfo);
                  localStorage.setItem("modelName", parsedSystemInfo.modelName);
                  localStorage.setItem("version", parsedSystemInfo.sdkVersion);
                  localStorage.setItem(
                    "modelCode",
                    parsedSystemInfo.firmwareVersion
                  );
                  localStorage.setItem("UHD", parsedSystemInfo.UHD);
                } else {
                  // console.log("Failed to get TV device information");
                }
              },
            }
          );
        }
      } catch (error) {
        console.error("Error fetching system info:", error);
      }
    };

    getSystemInfo();
  }, []);

  return (
    <div>
      {/* <h3>TV System Information</h3>
      <pre>{JSON.stringify(systemInfo, null, 2)}</pre> */}
    </div>
  );
};

// import React, { useEffect, useState } from "react";

const LGDeviceID = () => {
  const [deviceIDInfo, setDeviceIDInfo] = useState(null);

  useEffect(() => {
    const getDeviceID = async () => {
      try {
        if (window.webOS && window.webOS.service) {
          // console.log("webOS service is available");
          const request = window.webOS.service.request(
            "luna://com.webos.service.sm",
            {
              method: "deviceid/getIDs",
              parameters: {
                idType: ["LGUDID"],
              },
              onSuccess: (inResponse) => {
                setDeviceIDInfo(inResponse);
                localStorage.setItem(
                  "deviceIDInfo",
                  JSON.stringify(inResponse)
                );
                // console.log("Device ID Info data:", inResponse);
                // localStorage.setItem(
                //   "uuid",
                //   inResponse.idList[0].idType
                // );
                // localStorage.setItem(
                //   "macAddress",
                //   inResponse.idList[0].idValue
                // );
                const deviceIDInfo = localStorage.getItem("deviceIDInfo");
                const parsedDeviceIDInfo = JSON.parse(deviceIDInfo);
                localStorage.setItem("parsedDeviceIDInfo", parsedDeviceIDInfo);

                console.log("parsedDeviceIDInfo:", parsedDeviceIDInfo);

                if (
                  parsedDeviceIDInfo &&
                  Array.isArray(parsedDeviceIDInfo.idList) &&
                  parsedDeviceIDInfo.idList.length > 0
                ) {
                  const { idType, idValue } = parsedDeviceIDInfo.idList[0];
                    console.log("idType:", idType);
                    console.log("idValue:", idValue);
                  if (idType && idValue) {
                    localStorage.setItem("uuid_", idType);
                    localStorage.setItem("macAddress_", idValue);
                    console.log("Set UUID and MAC Address:", idType, idValue);
                  } else {
                    console.error("idType or idValue missing in idList[0]");
                  }
                } else {
                  console.error("Invalid parsedDeviceIDInfo or empty idList");
                }
                

                // localStorage.setItem(
                //   "uuid",
                //   parsedDeviceIDInfo.idList[0].idType
                // );
                // localStorage.setItem(
                //   "macAddress",
                //   parsedDeviceIDInfo.idList[0].idValue
                // );
              },
              onFailure: (inError) => {
                // console.log("Failed to get system ID information");
              },
            }
          );
        }
      } catch (error) {
        console.error("Error fetching device ID info:", error);
      }
    };

    getDeviceID();
  }, []);

  return (
    <div>
      {/* <h3>Device ID Information</h3>
      <pre>{JSON.stringify(deviceIDInfo, null, 2)}</pre> */}
    </div>
  );
};

// export default LGDeviceID;

export { LGTVInfo, LGDeviceID };
